import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  IconButton,
} from "@mui/material";
import { data } from "./Data";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

// Modal Style
const style = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
};
const OurWork = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleViewMore = (item) => {
    setSelectedItem(item);
    handleOpen();
  };

  return (
    <>
      <Box
        sx={{
          padding: { xs: "5vh 8vw", md: "5vh 12vw" },
          marginTop: "15vh",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 800,
            color: "#363435",
            fontSize: { xs: "3rem", sm: '4rem', md: "6.75rem" },
            fontFamily: "Switzer-Variable",
            marginBottom: "5vh"
          }}
        >
          Our Work{" "}
        </Typography>

        <Typography
          variant="p"
          sx={{
            fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
            color: "#363435",
            fontFamily: "Switzer-Variable",
            fontWeight: 300
          }}
        >
          We create brand experiences the clients love
        </Typography>

        <Grid container spacing={3}>
          {data.map((item) => (
            <Grid
              item
              md={3}
              sm={6}
              xs={9}
              onClick={() => handleViewMore(item)}
              sx={{
                cursor: "pointer",
                margin: { xs: "auto", sm: 0 }
              }}
              key={item.id}
            >
              <Paper
                elevation={5}
                sx={{
                  position: "relative",
                  zIndex: 1,
                  display: "flex",
                  flexDirection: "column",
                  flexShrink: 0,
                  justifyContent: "flex-start",
                  gap: 2,
                  p: 2,
                  marginTop: "20px",
                  height: { md: "20vh", sm: "30vh" },
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <img
                  src={`assets/${item.logo}`}
                  alt={item.name}
                  width={item.logoW}
                  height={item.logoH}
                  style={{
                    marginBottom: item.mBtm,
                    marginTop: item.mTop
                  }}
                />

                <Typography
                  variant="p"
                  sx={{
                    fontSize: { xs: '0.9rem', md: "0.8rem" },
                  }}
                >
                  {item.name}
                </Typography>
              </Paper>
              <Box
                sx={{
                  backgroundColor: "#2F5325",
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                  marginTop: "-3px",
                  position: "relative",
                  zIndex: 0,
                  p: "5px 15px",
                }}
              >
                <Typography
                  variant="p"
                  sx={{ color: "white", fontSize: "14px" }}
                >
                  View more
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      {
        open ?
          <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
              <Box
                display="flex"
                justifyContent="start"
                alignItems="center"
                gap={2}
                width="80%"
                sx={{ flexDirection: { xs: "column", sm: "row" } }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 1,
                    borderRadius: "10px",
                  }}
                >
                  <img src={`assets/${selectedItem.logo}`} alt="" width={selectedItem.logoW} height={selectedItem.logoH} />
                </Box>
                <Box>
                  <Typography
                    variant="p"
                    sx={{ color: "white", fontWeight: "bold" }}
                  >
                    {selectedItem.name}
                  </Typography>
                </Box>
              </Box>

              <Carousel
                showThumbs={false}
                showIndicators={false}
                selectedItem={0}
                renderArrowPrev={(onClickHandler, hasPrev, label) =>
                  hasPrev && (
                    <IconButton
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        zIndex: 2,
                        position: "absolute",
                        top: "50%",
                        left: "2%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        backgroundColor: "black"
                      }}
                    >
                      <ArrowBackIosIcon sx={{ color: "white" }} />
                    </IconButton>
                  )
                }
                renderArrowNext={(onClickHandler, hasNext, label) =>
                  hasNext && (
                    <IconButton
                      onClick={onClickHandler}
                      title={label}
                      style={{
                        zIndex: 2,
                        position: "absolute",
                        top: "50%",
                        right: "2%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        backgroundColor: "black"
                      }}
                    >
                      <ArrowForwardIosIcon sx={{ color: "white" }} />
                    </IconButton>
                  )
                }
              >
                <div>
                  {/* <Box
                    display="flex"
                    justifyContent="start"
                    alignItems="center"
                    gap={2}
                    sx={{
                      flexDirection: { xs: "column", sm: "row" },
                      p: "0px 100px",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "white",
                        height: "100px",
                        width: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 1,
                        borderRadius: "10px",
                      }}
                    >
                      <img src={`assets/${selectedItem.logo}`} alt="" width={selectedItem.logoW} height={selectedItem.logoH} />
                    </Box>
                    <Box display="flex" alignItems="start">
                      <Typography
                        variant="p"
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          textAlign: "start",
                        }}
                      >
                        {selectedItem.name}
                      </Typography>
                    </Box>
                  </Box> */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      variant="p"
                      sx={{
                        color: "white",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      {selectedItem.imgLabel[0]}
                    </Typography>
                  </Box>
                  <img
                    src={`assets/${selectedItem.img1}`}
                    alt="1"
                    style={{
                      maxHeight: `${selectedItem.imgH[0]}`,
                      maxWidth: `${selectedItem.imgW[0]}`,
                      margin: "auto",
                      display: "block",
                    }}
                  />
                </div>

                <div>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      variant="p"
                      sx={{
                        color: "white",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      {selectedItem.imgLabel[1]}
                    </Typography>
                  </Box>
                  <img
                    src={`assets/${selectedItem.img2}`}
                    alt="2"
                    style={{
                      maxHeight: `${selectedItem.imgH[1]}`,
                      maxWidth: `${selectedItem.imgW[1]}`,
                      margin: "auto",
                      display: "block",
                    }}
                  />
                </div>
                <div>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      variant="p"
                      sx={{
                        color: "white",
                        fontSize: "16px",
                        textAlign: "center",
                      }}
                    >
                      {selectedItem.imgLabel[2]}
                    </Typography>
                  </Box>
                  <img
                    src={`assets/${selectedItem.img3}`}
                    alt="3"
                    style={{
                      maxHeight: `${selectedItem.imgH[2]}`,
                      maxWidth: `${selectedItem.imgW[2]}`,
                      margin: "auto",
                      display: "block",
                    }}
                  />
                </div>

                {
                  selectedItem.img4 ?
                    <div>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          variant="p"
                          sx={{
                            color: "white",
                            fontSize: "16px",
                            textAlign: "center",
                          }}
                        >
                          {selectedItem.imgLabel[3]}
                        </Typography>
                      </Box>
                      <img
                        src={`assets/${selectedItem.img4}`}
                        alt="4"
                        style={{
                          maxHeight: `${selectedItem.imgH[3]}`,
                          maxWidth: `${selectedItem.imgW[3]}`,
                          margin: "auto",
                          display: "block",
                        }}
                      />
                    </div>
                    :
                    <div>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          variant="p"
                          sx={{
                            color: "white",
                            fontSize: "16px",
                            textAlign: "center",
                          }}
                        >
                          {selectedItem.imgLabel[1]}
                        </Typography>
                      </Box>
                      <img
                        src={`assets/${selectedItem.img2}`}
                        alt="2"
                        style={{
                          maxHeight: `${selectedItem.imgH[1]}`,
                          maxWidth: `${selectedItem.imgW[1]}`,
                          margin: "auto",
                          display: "block",
                        }}
                      />
                    </div>

                }

                {
                  selectedItem.img5 ?
                    <div>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          variant="p"
                          sx={{
                            color: "white",
                            fontSize: "16px",
                            textAlign: "center",
                          }}
                        >
                          {selectedItem.imgLabel[4]}
                        </Typography>
                      </Box>
                      <img
                        src={`assets/${selectedItem.img5}`}
                        alt="5"
                        style={{
                          maxHeight: `${selectedItem.imgH[4]}`,
                          maxWidth: `${selectedItem.imgW[4]}`,
                          margin: "auto",
                          display: "block",
                        }}
                      />
                    </div>
                    :
                    <div>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          variant="p"
                          sx={{
                            color: "white",
                            fontSize: "16px",
                            textAlign: "center",
                          }}
                        >
                          {selectedItem.imgLabel[4]}
                        </Typography>
                      </Box>
                      <img
                        src={`assets/${selectedItem.img1}`}
                        alt="1"
                        style={{
                          maxHeight: `${selectedItem.imgH[4]}`,
                          maxWidth: `${selectedItem.imgW[4]}`,
                          margin: "auto",
                          display: "block",
                        }}
                      />
                    </div>
                }

              </Carousel>

              <CloseIcon
                sx={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "2rem",
                }}
                onClick={handleClose}
              />
            </Box>
          </Modal>
          : ""
      }

    </>
  );
};

export default OurWork;